import React, { Component } from 'react';
import Spinner from './../../images/purple_spinner.gif';

export class Loading extends Component {

    render() {
        return(
            <div>
                <div><img src={Spinner} style={{marginTop: '90px'}} /></div>
                <div>
                    <p style={{textAlign: 'center'}}>{this.props.showMessage('message_14_01')}</p>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/preview/Loading.jsx